import React from "react";
import phoneIcon from "../assets/svg/phoneIcon.svg";
import mailIcon from "../assets/svg/mailIcon.svg";
import joulezLightIcon from "../assets/svg/JoulezLightIcon.svg";

const RentalDetailsFooter = () => {
  return (
    <div className="d-flex flex-column justify-content-center text-center bgF2F0FD p-3 fontAntarctica">
      <div className="fontWeight400">
        <div className="p-1 mb-3"><img src={joulezLightIcon} alt="joulezLightIcon" /></div>
        <div className="p-1">5 Columbus Circle FL 16,</div>
        <div className="p-1">New York, NY 10019</div>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <div>
          <a
            className="text-decoration-none fontColorCE1"
            href="mailto:info@drivejoulez.com"
          >
            <img src={mailIcon} alt="mailIcon" className="px-1" />
            <span className="fontSize13 fontWeight500">info@drivejoulez.com</span>
          </a>
        </div>
        <div className="fontSize13 mx-3">
          <img src={phoneIcon} alt="phoneIcon" className="px-1" />
          <a
            href="tel:+14452568539"
            className="text-decoration-none fontColorCE1 fontWeight500"
          >
            +1 (445) 256-8539
          </a>
        </div>
      </div>
    </div>
  );
};

export default RentalDetailsFooter;
